// extracted by mini-css-extract-plugin
export default {"modalComponent":"Gfe8587","modalTitle":"Ge17b0b","modalContent":"Gba0ada","modalFooter":"G751d83"};